import React from "react";
import '../styles/Experience.css';


class Experience extends React.Component{
    render(){
        const { workExperiences } = this.props;

        return(
            <div className="work-experience-div">
                <div className="sub-title-div">
                    <p className="tc">Work Experience</p>
                </div>
                <div className="experience-container">
                    {workExperiences.map((experience, index) => (
                        <div className="experience" key={index}>
                            <div className="company-info">
                                <a href={experience.link} target="_blank">
                                    <img src={experience.logo} alt={`${experience.company} logo`} className="company-logo animate-grow" />
                                </a>
                            </div>
                            <div className="experience-details">
                                <p className="role">{experience.role}</p>
                                <p className="duration">{experience.duration}</p>
                                <p className="description">{experience.description}</p>
                            </div>
                        </div>
                    ))}
                </div>

            </div>  
        );
    }
}

export default Experience;